import { useSections } from "@/contexts/classified";
export const useMainDescription = () => { var _a, _b; return (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.mainDescription) !== null && _b !== void 0 ? _b : {}; };
export const useAreaDescription = () => { var _a, _b; return (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.areaDescription) !== null && _b !== void 0 ? _b : {}; };
export const useExtendedInfoDescription = () => { var _a, _b; return (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.extendedInfoDescription) !== null && _b !== void 0 ? _b : {}; };
export const useMainDescriptionText = () => {
    const { headline, description } = useMainDescription();
    return {
        headline,
        text: description !== null && description !== void 0 ? description : "",
    };
};
export const useLocationDescriptionText = () => {
    const { headline, description } = useAreaDescription();
    return {
        headline: headline,
        text: description !== null && description !== void 0 ? description : "",
    };
};
export const useAdditionalDescriptionText = () => {
    const { headline, description } = useExtendedInfoDescription();
    return {
        headline: headline,
        text: description !== null && description !== void 0 ? description : "",
    };
};
